import useTranslation from 'next-translate/useTranslation'

import ButtonText from '@/components/ui/Typo/ButtonText'
import H2 from '@/components/ui/Typo/H2'
import { NAMESPACE_HOSTING } from '@/res/namespaces'
import { IFreeTrialPopup } from '@/types/Hosting'
import { numberWithSpaces } from '@/utils/numberWithSpaces'

interface Props {
  price: number
  ssd: string
  isPopular: boolean
  mailboxes: string
  alternative: string
  subdomains: string
  name: string
  db: string
  second_level: string
  hasTrial: boolean
  id: number
  onSelectPlan: (id: number) => any
  onFreeTrialClick: (info: IFreeTrialPopup) => void
}

function HostCard({
  price,
  ssd,
  alternative,
  name,
  db,
  mailboxes,
  second_level,
  hasTrial,
  onFreeTrialClick,
  subdomains,
  onSelectPlan,
  id,
  isPopular,
}: Props) {
  const { t } = useTranslation(NAMESPACE_HOSTING)
  return (
    <div className="bg-white relative flex flex-col tablet:px-6 small:px-6 p-5 border-2 small:py-6 hr:max-w-[400px] rounded">
      {isPopular && (
        <div className="absolute -right-6 top-8 rotate-45 bg-primary rounded px-5 py-1">
          <p className="text-base font-medium text-white">{t('top_sale')}</p>
        </div>
      )}
      <div className="laptop:text-[20px] tablet:text-[19px] small:text-[18px] text-[16px] font-semibold text-[#80899B] tablet:pb-6 small:pb-6 pb-4 border-b-[2px] ">
        <H2 uppercase={false} color="text-gray3" weight="font-semibold">
          {name}
        </H2>
        <ButtonText
          color="text-primary"
          size="big"
          weight="font-semibold"
          className=" my-2 small:my-2"
        >
          {numberWithSpaces(price)} {t('card_price')}
        </ButtonText>
      </div>
      <div className="tablet:py-4 py-2 flex-1 flex flex-col justify-between">
        <div>
          <div className="flex my-2 items-center  laptop:text-[20px] tablet:text-[19px] small:text-[18px] text-[16px]  text-[#74787B]  ">
            <p className="hr:text-[28px] desktop:text-[26px] laptop:text-[25px] tablet:text-[24px] small:text-[23px] text-[22px] font-bold text-[#3D4153] mr-3">
              {ssd}
            </p>
            {t('card_ssd')}
          </div>
          <div className="flex my-2 mall:my-2 laptop:text-[20px] tablet:text-[19px] small:text-[18px] text-[16px] items-start text-[#74787B]">
            <p className="font-bold text-[#3D4153] mr-3 text-xl tablet:text-3xl ">
              {second_level}
            </p>
            {t('card_second_level')}
          </div>
          <div className="flex  my-2 mall:my-2   laptop:text-[20px] tablet:text-[19px] small:text-[18px] text-[16px] items-center text-[#74787B]">
            <p className="font-bold text-[#3D4153] mr-3 text-xl tablet:text-3xl">
              {db === 'unlimited' ? '∞' : db}
            </p>
            {t('card_db')}
          </div>
          <div className="flex my-2 mall:my-2   laptop:text-[20px] tablet:text-[19px] small:text-[18px] text-[16px] items-center text-[#74787B]">
            <p className="font-bold text-[#3D4153] mr-3 text-xl tablet:text-3xl ">
              {subdomains === 'unlimited' ? '∞' : subdomains}
            </p>
            {t('card_subdomains')}
          </div>
          <div className="flex my-2 mall:my-2   laptop:text-[20px] tablet:text-[19px] small:text-[18px] text-[16px] items-start text-[#74787B]">
            <p className="font-bold text-[#3D4153] mr-3 text-xl tablet:text-3xl ">
              {alternative === 'unlimited' ? '∞' : alternative}
            </p>
            {t('card_alternative')}
          </div>
          <div className="flex items-center my-2 mall:my-2   laptop:text-[20px] tablet:text-[19px] small:text-[18px] text-[16px] text-[#74787B]">
            <p className="font-bold text-[#3D4153] mr-3 text-xl tablet:text-3xl ">
              {mailboxes === 'unlimited' ? '∞' : mailboxes}
            </p>
            {t('card_mailboxes')}
          </div>
          <div className="flex small:my-2   laptop:text-[20px] tablet:text-[19px] small:text-[18px] text-[16px] items-center text-[#74787B]">
            {t('card_plesk')}
          </div>
        </div>
        <div>
          {hasTrial ? (
            <button
              onClick={() => onFreeTrialClick({ id, planName: name })}
              className="bg-green-500 hover:bg-green-500/80 transition-colors text-white p-3 rounded-lg w-full"
            >
              {t('free_trial', { days: 3 })}
            </button>
          ) : null}
          <button
            onClick={() => onSelectPlan(id)}
            className="py-3 px-5 mt-3 hr:text-[20px] desktop:text-[18px] laptop:text-[16px] tablet:text-[14px] small:text-[14px] text-[14px] tablet:px-8  hover:scale-105 transition ease-in-out hover:bg-[#35aafd] bg-[#1989d8] cursor-pointer font-semibold rounded-lg text-white w-full"
          >
            {t('card_order')}
          </button>
          <p className="hr:text-[18px] desktop:text-[17px] laptop:text-[16px] tablet:text-[15px] small:text-[14px] text-[14px] text-[#74787B] mt-7">
            {t('card_ssl_certificate')}
          </p>
        </div>
      </div>
    </div>
  )
}

export default HostCard
